export const LIST_USERS_TABLE = {
  USER_ID_COLUMN_HEADER: 'User ID',
  USER_NAME_COLUMN_HEADER: 'User Name',
  EMAIL_ID_COLUMN_HEADER: 'Email',
  ROLE_COLUMN_HEADER: 'Role',
  ACTIONS_COLUMN_HEADER: 'Actions',
};

export const LIST_USER_PAGE = {
  PAGE_HEADER: 'List User',
  ACCOUNT_ID_FIELD_NAME: 'Account ID',
  LIST_USER_TABLE_HEADER: 'User Lists',
  LIST_USER_NO_DATA_ERROR_RESPONSE: 'Internal error while retrieving data',
  NO_RESULTS_MESSAGE: 'No users associated with this account',
  REMOVE_USER_GENERIC_ERROR_MESSAGE: 'Unable to remove user from account.',
  REMOVE_USER_SUCCESS_MESSAGE: 'User removed successfully',
};

export const ADD_USER_PAGE = {
  PAGE_HEADER: 'Add User',
  ADD_USER_SUCCESS_MESSAGE: 'User addition is successful',
  ADD_USER_DEFAULT_ERROR_MESSAGE: 'Unable to add user.',
  FIELD_USER_TYPE_LABEL: 'User Type*',
  FIELD_USER_TYPE_CONSTRAINT_LABEL: 'Select the type of user',
  FIELD_ACCOUNT_ID_LABEL: 'Account Id*',
  FIELD_ACCOUNT_ID_CONSTRAINT_LABEL:
    'Select the Account ID you want the user to add',
  FIELD_ROLE_LABEL: 'Role*',
  FIELD_ROLE_CONSTRAINT_LABEL: 'Select the role for the user',
  FIELD_INTERNAL_EMAIL_ALIAS_LABEL: 'Alias*',
  FIELD_INTERNAL_EMAIL_ALIAS_CONSTRAINT_LABEL:
    'Provide the amazon alias of the user. Eg: If the email is someone@amazon.com just add someone',
  FIELD_EXTERNAL_EMAIL_LABEL: 'Email Id*',
  FIELD_EXTERNAL_EMAIL_CONSTRAINT_LABEL:
    'Provide the email id of the user. This email id should be of an Amazon retail user',
  SUBMIT_BUTTON_LABEL: 'Submit',
};

export const VALIDATION = {
  MANDATORY_FIELD_MESSAGE: 'This is a mandatory field.',
  INVALID_EMAIL_MESSAGE: 'The email id is invalid.',
};
